import { Injectable } from '@angular/core';
import { CountryItem } from '@models/dashboard.model';
import { ShoppingDataInitialLoad } from '@models/shopping.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {
  private filters_param: ShoppingDataInitialLoad & { countryId: number };
  private _country: CountryItem | undefined = undefined;
  readonly filter_changes: BehaviorSubject<ShoppingDataInitialLoad & { countryId: number }>;

  constructor() {
    this.filters_param = { ...this.defaultFilters(), countryId: 0 };
    this.filter_changes = new BehaviorSubject<ShoppingDataInitialLoad & { countryId: number }>(
      this.filters_param
    );
  }

  set filtersParam(value: ShoppingDataInitialLoad) {
    this.filters_param = { ...value, countryId: this._country?.id ?? 0 };
    this.filter_changes.next(this.filters_param);
  }

  get filtersParam(): ShoppingDataInitialLoad & { countryId: number } {
    return this.filters_param;
  }

  set country(value: CountryItem | undefined) {
    this._country = value;
    this.filtersParam = this.defaultFilters();
  }

  get country(): CountryItem | undefined {
    return this._country;
  }

  defaultFilters(): ShoppingDataInitialLoad {
    return { categories: [], filters: [], orderTypeId: 1, deviceId: -1 };
  }

  reset(): void {
    this.filtersParam = this.defaultFilters();
  }
}
